module.exports = __webpack_public_path__ + "assets/img/0c78-dm.svg";